import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { Box } from '@mui/material';
import { timeFormatter } from '@act/shared/utilities';
import { DueDateAlertIcon } from './DueDateAlertIcon';
import { determineDateLineTextColor } from '../../utilities';
import { DateTime } from 'luxon';

interface AssignedSurveyDateLineProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
}

export const AssignedSurveyDateLine = ({
  assignedSurvey,
  member,
}: AssignedSurveyDateLineProps) => {
  if (member?.memberStage?.key === 'outreach' || !assignedSurvey?.dueAt) {
    return null;
  }
  const currentPhase = assignedSurvey.phases
    .filter(phase => phase.checkpoint && phase.completedAt)
    .sort((a, b) => b.completedAt - a.completedAt)[0];

  let dueDate =
    assignedSurvey.completedAt ||
    currentPhase?.nextPhaseDueAt ||
    assignedSurvey?.dueAt;

  if (typeof dueDate === 'string') {
    dueDate = DateTime.fromISO(dueDate).toMillis();
  }

  const dateColor = determineDateLineTextColor(assignedSurvey, dueDate);

  const formattedDueDate = timeFormatter.epochToShortMonthDay(dueDate);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        paddingRight: '8px',
        ...(dateColor && { color: dateColor }),
      }}
    >
      <DueDateAlertIcon
        dueDate={dueDate}
        isCompleted={assignedSurvey.completed}
      />
      {formattedDueDate}
    </Box>
  );
};
